import { execAdmin } from '@src/apis/reware/utils';

import type {
  PricingFilters,
  PricingRulesConnection,
  FetchPricingRulesExecVariables,
  FetchPricingRulesExecResponse,
} from './types';

export interface FetchPricingRulesArgs {
  partnerId: number;
  pricingType: string;
  first?: number;
  after?: string | null;
  filters?: PricingFilters;
}

export const fetchPricingRules = async ({
  partnerId,
  pricingType,
  first = 50,
  after = null,
  filters = {},
}: FetchPricingRulesArgs): Promise<PricingRulesConnection> => {
  const query = `
    query getPricingRules(
      $partnerId: Int!
      $pricingType: String!
      $first: Int
      $after: String
      $filters: PricingFiltersInput
    ) {
      partner(id: $partnerId) {
        pricingRules(
          pricingType: $pricingType
          first: $first
          after: $after
          filters: $filters
        ) {
          edges {
            node {
              id
              position
              condition
              department
              category
              merchantCategory
              tag
              name
              secondaryTag
              secondaryName
              tertiaryTag
              tertiaryName
              discount
              sourceColumn
              upc
            }
            cursor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          totalCount
          initiatedAt
          processedAt
        }
      }
    }
  `;

  // Only include filters if they have non-empty values
  const cleanedFilters = Object.entries(filters)
    .filter(([, value]) => value != null && value !== '')
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

  const data = await execAdmin<FetchPricingRulesExecVariables, FetchPricingRulesExecResponse>(
    query,
    {
      variables: {
        partnerId,
        pricingType,
        first,
        after,
        filters: Object.keys(cleanedFilters).length > 0 ? cleanedFilters : undefined,
      },
    }
  );

  return data.partner.pricingRules;
};
